import VueTippy, { TippyComponent } from 'vue-tippy'

import AhaExtraBadge from './components/UI/badge/ExtraBadge.vue'
import AhaAccordion from './components/UI/accordion/Accordion.vue'
import AhaAccordionItem from './components/UI/accordion/AccordionItem.vue'

import AhaBadge from './components/UI/badge/Badge.vue'
import AhaPlanBadge from './components/UI/badge/PlanBadge.vue'
import AhaPillBadge from './components/UI/badge/PillBadge.vue'

import AhaContextMenu from './components/UI/context-menu/ContextMenu.vue'
import AhaContextMenuDivider from './components/UI/context-menu/ContextMenuDivider.vue'
import AhaContextMenuHeader from './components/UI/context-menu/ContextMenuHeader.vue'
import AhaContextMenuItem from './components/UI/context-menu/ContextMenuItem.vue'

import AhaDropdown from './components/UI/dropdown/Dropdown.vue'
import AhaDropdownItem from './components/UI/dropdown/DropdownItem.vue'
import AhaDropdownItems from './components/UI/dropdown/DropdownItems.vue'
import AhaDropdownTrigger from './components/UI/dropdown/DropdownTrigger.vue'

import AhaChat from './components/UI/live-chat/Chat.vue'
import AhaChatToggle from './components/UI/live-chat/ChatToggle.vue'
import AhaChatBox from './components/UI/live-chat/ChatBox.vue'

import AhaTabs from './components/UI/tab/Tabs.vue'
import AhaTabsPrimary from './components/UI/tab/TabsPrimary.vue'
import AhaTabItem from './components/UI/tab/TabItem.vue'

import AhaAvatar from './components/UI/Avatar.vue'
import AhaTeamAvatar from './components/UI/TeamAvatar.vue'
import AhaButton from './components/UI/Button.vue'
import AhaButtonFixedWidth from './components/UI/ButtonFixedWidth.vue'
import AhaButtonV2 from './components/UI/Buttonv2.vue'
import AhaCheckbox from './components/UI/Checkbox.vue'
import AhaClipboard from './components/UI/Clipboard.vue'
import AhaClipboardGeneral from './components/UI/ClipboardGeneral.vue'
import AhaFormatter from './components/UI/Formatter.vue'
import AhaIcon from './components/UI/Icon.vue'
import AhaSvg from './components/UI/Svg.vue'
import AhaIconContainer from './components/UI/IconContainer.vue'
import AhaInfoBox from './components/UI/InfoBox.vue'
import AhaInput from './components/UI/Input.vue'
import AhaInputSearch from './components/UI/InputSearch.vue'
import AhaInputGroup from './components/UI/InputGroup.vue'
import AhaInputPassword from './components/UI/InputPassword.vue'
import AhaLoadingDots from './components/UI/LoadingDots.vue'
import AhaLink from './components/UI/Link.vue'
import AhaLogo from './components/UI/Logo.vue'
import AhaModal from './components/UI/Modal.vue'
import AhaModalGroup from './components/UI/ModalGroup.vue'
import AhaRadio from './components/UI/Radio.vue'
import AhaSection from './components/UI/Section.vue'
import AhaSelect from './components/UI/select/Select.vue'
import AhaSelectOption from './components/UI/select/SelectOption.vue'
import AhaSlideUp from './components/UI/SlideUp.vue'
import AhaSpinner from './components/UI/Spinner.vue'
import AhaTextarea from './components/UI/Textarea.vue'
import AhaDropdownButton from './components/UI/DropdownButton.vue'
import AhaBreadcrumb from './components/UI/breadcrumb/Breadcrumb.vue'
import AhaBreadcrumbItem from './components/UI/breadcrumb/BreadcrumbItem.vue'
import AhaLottiePlayer from './components/UI/lottie-player/LottiePlayer.vue'
import AhaProfanityFilter from './utils/profanity-filter/ProfanityFilter.vue'
import AhaInputTag from './components/UI/InputTag.vue'
import AhaInputTagObject from './components/UI/InputTagObject.vue'
import AhaPagination from './components/UI/Pagination.vue'
import AhaProgressCircle from './components/UI/ProgressCircle.vue'
import AhaSkeletonLoader from './components/UI/SkeletonLoader.vue'
import AhaLogoLoader from './components/UI/LogoLoader.vue'
import AhaShortcutKey from './components/UI/ShortcutKey.vue'
import Displayer from './components/UI/Displayer'
import StarRating from './components/UI/StarRating.vue'
import StarRatingView from './components/UI/StarRatingView.vue'
import AhaWebm from './components/UI/Webm.vue'
import AhaCustomTooltip from './components/UI/CustomTooltip.vue'
import AhaButtonLink from './components/UI/ButtonLink.vue'
import AhaToggleTip from './components/UI/ToggleTip.vue'

// package
import { version } from '../package.json'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/themes/light.css'

const install = (Vue) => {
  Vue.use(VueTippy, {
    directive: 'aha-tooltip',
  })

  Vue.component('AhaTooltip', TippyComponent)
  Vue.component('AhaAccordion', AhaAccordion)
  Vue.component('AhaAccordionItem', AhaAccordionItem)

  Vue.component('AhaBadge', AhaBadge)
  Vue.component('AhaPlanBadge', AhaPlanBadge)
  Vue.component('AhaPillBadge', AhaPillBadge)

  Vue.component('AhaContextMenu', AhaContextMenu)
  Vue.component('AhaContextMenuDivider', AhaContextMenuDivider)
  Vue.component('AhaContextMenuHeader', AhaContextMenuHeader)
  Vue.component('AhaContextMenuItem', AhaContextMenuItem)

  Vue.component('AhaDropdown', AhaDropdown)
  Vue.component('AhaDropdownItem', AhaDropdownItem)
  Vue.component('AhaDropdownItems', AhaDropdownItems)
  Vue.component('AhaDropdownTrigger', AhaDropdownTrigger)

  Vue.component('AhaChat', AhaChat)
  Vue.component('AhaChatToggle', AhaChatToggle)
  Vue.component('AhaChatBox', AhaChatBox)

  Vue.component('AhaTabs', AhaTabs)
  Vue.component('AhaTabsPrimary', AhaTabsPrimary)
  Vue.component('AhaTabItem', AhaTabItem)

  Vue.component('AhaAvatar', AhaAvatar)
  Vue.component('AhaTeamAvatar', AhaTeamAvatar)
  Vue.component('AhaButton', AhaButton)
  Vue.component('AhaButtonV2', AhaButtonV2)
  Vue.component('AhaButtonFixedWidth', AhaButtonFixedWidth)
  Vue.component('AhaCheckbox', AhaCheckbox)
  Vue.component('AhaClipboard', AhaClipboard)
  Vue.component('AhaClipboardGeneral', AhaClipboardGeneral)
  Vue.component('AhaFormatter', AhaFormatter)
  Vue.component('AhaIcon', AhaIcon)
  Vue.component('AhaSvg', AhaSvg)
  Vue.component('AhaIconContainer', AhaIconContainer)
  Vue.component('AhaInfoBox', AhaInfoBox)
  Vue.component('AhaInput', AhaInput)
  Vue.component('AhaInputSearch', AhaInputSearch)
  Vue.component('AhaInputGroup', AhaInputGroup)
  Vue.component('AhaInputPassword', AhaInputPassword)
  Vue.component('AhaLoadingDots', AhaLoadingDots)
  Vue.component('AhaLink', AhaLink)
  Vue.component('AhaLogo', AhaLogo)
  Vue.component('AhaModal', AhaModal)
  Vue.component('AhaModalGroup', AhaModalGroup)
  Vue.component('AhaRadio', AhaRadio)
  Vue.component('AhaSection', AhaSection)
  Vue.component('AhaSelect', AhaSelect)
  Vue.component('AhaSelectOption', AhaSelectOption)
  Vue.component('AhaSlideUp', AhaSlideUp)
  Vue.component('AhaSpinner', AhaSpinner)
  Vue.component('AhaTextarea', AhaTextarea)
  Vue.component('AhaDropdownButton', AhaDropdownButton)
  Vue.component('AhaBreadcrumb', AhaBreadcrumb)
  Vue.component('AhaBreadcrumbItem', AhaBreadcrumbItem)
  Vue.component('AhaLottiePlayer', AhaLottiePlayer)
  Vue.component('AhaProfanityFilter', AhaProfanityFilter)
  Vue.component('AhaInputTag', AhaInputTag)
  Vue.component('AhaInputTagObject', AhaInputTagObject)
  Vue.component('AhaPagination', AhaPagination)
  Vue.component('AhaProgressCircle', AhaProgressCircle)
  Vue.component('AhaSkeletonLoader', AhaSkeletonLoader)
  Vue.component('AhaDisplayer', Displayer)
  Vue.component('AhaLogoLoader', AhaLogoLoader)
  Vue.component('AhaShortcutKey', AhaShortcutKey)
  Vue.component('StarRating', StarRating)
  Vue.component('AhaStarRatingView', StarRatingView)
  Vue.component('AhaWebm', AhaWebm)
  Vue.component('AhaCustomTooltip', AhaCustomTooltip)
  Vue.component('AhaButtonLink', AhaButtonLink)
  Vue.component('AhaExtraBadge', AhaExtraBadge)
  Vue.component('AhaToggleTip', AhaToggleTip)
}

export default {
  install,
  version,
}
